import Axios from 'axios';

//const api = "http://192.168.0.5:8080/facilitapay/";
const api = "https://checkout.cliqx.com.br/pay/"




export default {

    validaLink(uuid){
        const headers   = { "Content-Type": "application/json" };
        const service = api + 'p/plan/' + uuid;
        
        return Axios.get(service, {headers});
    },

    enviaCheckout(body){

        var config = {
            method: 'post',
            url: api + 'p/v2/send/checkout',
            headers: { 'Content-Type': 'application/json' },
            data : body
          };

        //console.log(body);
        //const headers   = { "Content-Type": "application/json" };
        //const service = api + 'p/send/checkout';
        
        return Axios(config);
    },

    pesquisaCep(cep){

        var config = {
            method : 'get',
            url: 'https://viacep.com.br/ws/'+cep+'/json/',
            headers: { 'Content-Type': 'application/json' },
        }

        return Axios(config);
    }

}

